"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
        onToggle: function() {
          openTool("search", this.input.target);
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/DoSearch/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("96362d"),
    marko_node0 = marko_createElement("i", {
        "class": "bx bx-search"
      }, "1", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  out.e("span", {
      "class": marko_classValue(marko_classValue([
        "cursor-pointer",
        input.class
      ])),
      style: marko_styleValue(input.style),
      title: "Search " + (input.target || "...")
    }, "0", component, 1, 0, {
      onclick: __component.d("click", "onToggle", false)
    })
    .n(marko_node0, component);
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
